<div class="title">
	<a class="logo" routerLink="./"></a>
</div>

@if (showButtons) {
	<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Button for main menu">
		<mat-icon>menu</mat-icon>
	</button>
	<mat-menu #menu="matMenu">
		<a mat-menu-item routerLink="/appointments">
			<mat-icon>today</mat-icon>
			<span>Appointments</span>
		</a>

		<mat-divider></mat-divider>

		<button mat-menu-item (click)="logout()">
			<mat-icon>logout</mat-icon>
			<span>Logout</span>
		</button>
	</mat-menu>
}

